export { default } from './BidModalPrompts';
